import type { ReactNode } from "react";

export interface PageHeaderProps {
  action?: ReactNode;
  description?: string;
  title: string;
}

export function PageHeader({ action, description, title }: PageHeaderProps) {
  return (
    <header className="relative isolate flex flex-col gap-4 overflow-hidden rounded-card border border-line/80 bg-gradient-to-br from-surface via-surface/95 to-accent/[0.08] px-4 py-5 shadow-card ring-1 ring-line/20 sm:flex-row sm:items-end sm:justify-between sm:px-7 sm:py-6">
      <span
        aria-hidden="true"
        className="absolute inset-y-0 left-0 w-1.5 bg-gradient-to-b from-highlight via-gold to-accent"
      />
      <div className="relative">
        <h1 className="font-display text-3xl font-normal leading-tight text-ink min-[380px]:text-4xl sm:text-5xl">
          {title}
        </h1>
        {description && <p className="mt-2 max-w-2xl text-muted">{description}</p>}
      </div>
      {action && (
        <div className="relative min-w-0 shrink-0 [&>*]:w-full sm:[&>*]:w-auto">
          {action}
        </div>
      )}
    </header>
  );
}
